'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var nanoid = require('nanoid');

var _toString = require('uint8arrays/to-string');

var fromString = require('uint8arrays/from-string');

var pathSepS = '/';
var pathSepB = new TextEncoder().encode(pathSepS);
var pathSep = pathSepB[0];

var Key = /*#__PURE__*/function (_Symbol$toStringTag) {
  function Key(s, clean) {
    _classCallCheck(this, Key);

    if (typeof s === 'string') {
      this._buf = fromString.fromString(s);
    } else if (s instanceof Uint8Array) {
      this._buf = s;
    } else {
      throw new Error('Invalid key, should be String of Uint8Array');
    }

    if (clean == null) {
      clean = true;
    }

    if (clean) {
      this.clean();
    }

    if (this._buf.byteLength === 0 || this._buf[0] !== pathSep) {
      throw new Error('Invalid key');
    }
  }

  _createClass(Key, [{
    key: "toString",
    value: function toString() {
      var encoding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'utf8';
      return _toString.toString(this._buf, encoding);
    }
  }, {
    key: "uint8Array",
    value: function uint8Array() {
      return this._buf;
    }
  }, {
    key: _Symbol$toStringTag,
    get: function get() {
      return "Key(".concat(this.toString(), ")");
    }
  }, {
    key: "clean",
    value: function clean() {
      if (!this._buf || this._buf.byteLength === 0) {
        this._buf = pathSepB;
      }

      if (this._buf[0] !== pathSep) {
        var bytes = new Uint8Array(this._buf.byteLength + 1);
        bytes.fill(pathSep, 0, 1);
        bytes.set(this._buf, 1);
        this._buf = bytes;
      }

      while (this._buf.byteLength > 1 && this._buf[this._buf.byteLength - 1] === pathSep) {
        this._buf = this._buf.subarray(0, -1);
      }
    }
  }, {
    key: "less",
    value: function less(key) {
      var list1 = this.list();
      var list2 = key.list();

      for (var i = 0; i < list1.length; i++) {
        if (list2.length < i + 1) {
          return false;
        }

        var c1 = list1[i];
        var c2 = list2[i];

        if (c1 < c2) {
          return true;
        } else if (c1 > c2) {
          return false;
        }
      }

      return list1.length < list2.length;
    }
  }, {
    key: "reverse",
    value: function reverse() {
      return Key.withNamespaces(this.list().slice().reverse());
    }
  }, {
    key: "namespaces",
    value: function namespaces() {
      return this.list();
    }
  }, {
    key: "baseNamespace",
    value: function baseNamespace() {
      var ns = this.namespaces();
      return ns[ns.length - 1];
    }
  }, {
    key: "list",
    value: function list() {
      return this.toString().split(pathSepS).slice(1);
    }
  }, {
    key: "type",
    value: function type() {
      return namespaceType(this.baseNamespace());
    }
  }, {
    key: "name",
    value: function name() {
      return namespaceValue(this.baseNamespace());
    }
  }, {
    key: "instance",
    value: function instance(s) {
      return new Key(this.toString() + ':' + s);
    }
  }, {
    key: "path",
    value: function path() {
      var p = this.parent().toString();

      if (!p.endsWith(pathSepS)) {
        p += pathSepS;
      }

      p += this.type();
      return new Key(p);
    }
  }, {
    key: "parent",
    value: function parent() {
      var list = this.list();

      if (list.length === 1) {
        return new Key(pathSepS);
      }

      return new Key(list.slice(0, -1).join(pathSepS));
    }
  }, {
    key: "child",
    value: function child(key) {
      if (this.toString() === pathSepS) {
        return key;
      } else if (key.toString() === pathSepS) {
        return this;
      }

      return new Key(this.toString() + key.toString(), false);
    }
  }, {
    key: "isAncestorOf",
    value: function isAncestorOf(other) {
      if (other.toString() === this.toString()) {
        return false;
      }

      return other.toString().startsWith(this.toString());
    }
  }, {
    key: "isDecendantOf",
    value: function isDecendantOf(other) {
      if (other.toString() === this.toString()) {
        return false;
      }

      return this.toString().startsWith(other.toString());
    }
  }, {
    key: "isTopLevel",
    value: function isTopLevel() {
      return this.list().length === 1;
    }
  }, {
    key: "concat",
    value: function concat() {
      for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
        keys[_key] = arguments[_key];
      }

      return Key.withNamespaces([].concat(_toConsumableArray(this.namespaces()), _toConsumableArray(flatten(keys.map(function (key) {
        return key.namespaces();
      })))));
    }
  }], [{
    key: "withNamespaces",
    value: function withNamespaces(list) {
      return new Key(list.join(pathSepS));
    }
  }, {
    key: "random",
    value: function random() {
      return new Key(nanoid.nanoid().replace(/-/g, ''));
    }
  }, {
    key: "asKey",
    value: function asKey(other) {
      if (other instanceof Uint8Array || typeof other === 'string') {
        return new Key(other);
      }

      if (other.uint8Array) {
        return new Key(other.uint8Array());
      }

      return null;
    }
  }]);

  return Key;
}(Symbol.toStringTag);

function namespaceType(ns) {
  var parts = ns.split(':');

  if (parts.length < 2) {
    return '';
  }

  return parts.slice(0, -1).join(':');
}

function namespaceValue(ns) {
  var parts = ns.split(':');
  return parts[parts.length - 1];
}

function flatten(arr) {
  var _ref;

  return (_ref = []).concat.apply(_ref, _toConsumableArray(arr));
}

exports.Key = Key;